import { useState, useEffect } from 'react';
import { message } from 'antd';
import { history } from '@umijs/max';
import { outLogin } from '@/services/ant-design-pro/api';
import type { AppInitialState, Google2FAHandlers } from '../types';

export const useGoogle2FA = (
    initialState: AppInitialState,
    setInitialState: (state: AppInitialState | ((prev: AppInitialState) => AppInitialState)) => void
): [boolean, Google2FAHandlers] => {
    const [google2FAModalVisible, setGoogle2FAModalVisible] = useState(false);

    // 处理谷歌验证码绑定成功
    const handleGoogle2FASuccess = async () => {
        setGoogle2FAModalVisible(false);

        // 显示退出登录提示
        message.info('谷歌验证码绑定成功，正在退出登录...');

        try {
            // 调用退出登录接口
            await outLogin();

            // 清除本地状态
            setInitialState((prev) => ({
                ...prev,
                currentUser: undefined,
                currentUserMenu: undefined,
                showGoogle2FAModal: false,
                menuLastUpdated: undefined,
            }));

            // 跳转到登录页面
            history.push('/user/login');

            message.success('已退出登录，请重新登录');
        } catch (error) {
            console.error('退出登录失败:', error);
            // 即使退出失败，也跳转到登录页面
            history.push('/user/login');
        }
    };

    // 处理谷歌验证码弹窗取消
    const handleGoogle2FACancel = () => {
        setGoogle2FAModalVisible(false);
        setInitialState((prev) => ({
            ...prev,
            showGoogle2FAModal: false,
        }));
    };

    // 监听showGoogle2FAModal状态变化
    useEffect(() => {
        if (initialState?.showGoogle2FAModal) {
            setGoogle2FAModalVisible(true);
        }
    }, [initialState?.showGoogle2FAModal]);

    return [
        google2FAModalVisible,
        {
            onSuccess: handleGoogle2FASuccess,
            onCancel: handleGoogle2FACancel,
        },
    ];
};
